module.exports = __webpack_public_path__ + "img/maxlife.bb0a1451.png";